import * as Icons from "lucide-react";

export default function ConnectorIcon({ name, className }) {
  const Cmp = Icons[name] || Icons.Database;
  return <Cmp className={className} strokeWidth={1.5} />;
}
